/* product-showcase.js — rail click → hero stage swap + in-stage image scrub */
(function () {
  'use strict';

  document.querySelectorAll('[data-ps-section]').forEach(initShowcase);

  function initShowcase(section) {
    var stages     = section.querySelectorAll('.ps-product-stage');
    var railRows   = section.querySelectorAll('.ps-rail__row');
    var counter    = section.querySelector('.ps-hint__counter');
    var total      = stages.length;
    var activeIdx  = 0;

    if (!stages.length || !railRows.length) return;

    /* ── Image switcher within a single stage group ─────────────────── */
    function setStageImg(stage, imgIdx) {
      var imgs   = stage.querySelectorAll('.ps-stage__img');
      var thumbs = stage.querySelectorAll('.ps-stage__thumb');
      imgs.forEach(function (img, i)     { img.classList.toggle('is-active',   i === imgIdx); });
      thumbs.forEach(function (t, i)     { t.classList.toggle('is-active',     i === imgIdx); });
    }

    /* Attach thumb click handlers to every stage's thumbnail strip */
    stages.forEach(function (stage) {
      stage.querySelectorAll('.ps-stage__thumb').forEach(function (thumb, ti) {
        thumb.addEventListener('click', function (e) {
          e.stopPropagation();
          setStageImg(stage, ti);
        });
      });
    });

    /* ── Product switcher ────────────────────────────────────────────── */
    function switchTo(idx) {
      if (idx === activeIdx) return;

      stages[activeIdx].classList.remove('is-active');
      railRows[activeIdx].classList.remove('is-active');

      activeIdx = idx;

      stages[activeIdx].classList.add('is-active');
      railRows[activeIdx].classList.add('is-active');

      /* Reset hero to first image */
      setStageImg(stages[activeIdx], 0);

      /* Update counter */
      if (counter) counter.textContent = (activeIdx + 1) + ' of ' + total;

      /* Scroll the newly active row into view inside the rail */
      railRows[activeIdx].scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }

    railRows.forEach(function (row, i) {
      row.addEventListener('click', function () { switchTo(i); });
    });

    /* Initialise counter text */
    if (counter) counter.textContent = '1 of ' + total;
  }
})();
